export class AppSettings {
  public static CUSTOM_INTERFACE_BUTTON_DEFAULT_BACKGROUND = "#EAEAEA";
  public static CUSTOM_INTERFACE_BUTTON_DEFAULT_BORDER =
    "thin solid rgb(146 146 146)";

  //#region Network and Mqtt-connection related constants
  /**Default client-defined time-out value (in milliseconds) used to set "FETCH api/test", the "ping" API call to test connection to
   * API Server.
   *
   * This value is used in case we are using the LAN-specifi IP address of the selected plant.
   */
  public static DEFAULT_LAN_TIMEOUT_TESTAPI = 10000;

  /**Default client-defined time-out value (in milliseconds) used to set "FETCH api/test", the "ping" API call to test connection to
   * API Server.
   *
   * This value is used in case we are using the WAN-specifi IP address of the selected plant.
   */
  public static DEFAULT_WAN_TIMEOUT_TESTAPI = 10000;

  /**
   * The lower limit of the time interval (in seconds) after which "NEtwork.service", after the connection to API Server is re-estabilished,
   * will notify the pages/services to reload the  data
   */
  public static DEFAULT_MIN_AWAIT_AFTER_API_RECONNECTION = 10;

  /**
   * The upper limit of the time interval (in seconds) after which "NEtwork.service", after the connection to API Server is re-estabilished,
   * will notify the pages/services to reload the  data
   */
  public static DEFAULT_MAX_AWAIT_AFTER_API_RECONNECTION = 60;

  /**
   * Deafult period (in milliseconds) of the "heartbeatpolling"; this is the interval between each execution of the
   * "FETCH api/test", the "ping" API call to test connection to API Server.
   */
  public static DEFAULT_INTERVAL_HEARTBIT =
    AppSettings.DEFAULT_LAN_TIMEOUT_TESTAPI + 1000;

  /*
    INFO about stages used for defining the "API server polling" interval:




      //Network.service	
              TIME INTERVAL BETWEEN EACH CONSECUTIVE "api/system/test" CALL 		  TOTAL CONTINUOUS PERIOD WITHOUT CONNECTION			                  RANGE OF FAILED ATTEMPTS TO WHICH THE INTERVAL IS APPLIED
                      (the "INTERVAL_HEARTBIT_STAGE_X" interval )               (AT THE END OF THE PARTICULAR FAILED ATTEMPTS RANGE)            (each of them constitutes a different "polling stage", or simply "stage")
        1.    																												                                              
                                  11s												                              220s (3m 30s)						                                 [2-20] 
      	
        2. 																															                                              
                                  30s												                              820s (13m 30s) 				                                   [21-40]
      	
        3.																																	                                              
                                  60s 	(1m)												                      2020s (33m 30s)				                                    [41-60]
          	
        4.																															                                             
                                  120s	 (2m)								                              4420s (1h 13m 30s)			                                  [61-80]
          	
        5. 				 																												                                            
                                  300s		(5m)										                        10420s (2h 53m 30s)			                                  [81-100]
          	
          	
          	
      //Error-content.component [only in ACCESS_CONTROL_MODE]
        
            TIME INTERVAL BETWEEN EACH CONSECUTIVE "api/system/test" CALL           TOTAL CONTINUOUS PERIOD WITHOUT CONNECTION                      RANGE OF FAILED ATTEMPTS TO WHICH THE INTERVAL IS APPLIED         
                      (the "INTERVAL_HEARTBIT_STAGE_X" interval )               (AT THE END OF THE PARTICULAR FAILED ATTEMPTS RANGE)            (each of them constitutes a different "polling stage", or simply "stage")
            
      1.        
                                    [12s - 17s]										                        [4m - 5m 40s] 									                            [2-20]
          	
        2. 				
                                  [30s - 45s]										                        [14m - 20m 40s]									                            [21-40]
          	
        3. 				
                                  [60s - 75s]		      ([1m - 1m 15s])				                  [34m - 45m 40s]									                            [41-60]
          	
        4. 				
                                [120s - 135s]	       ([2m - 2m 15s])							           [1h 14m - 1h 30m]								                          [61-80]
          	
        5. 				
                                [300s - 315s]		    ([5m - 5m 15s])								       [2h 54m - 3h 09m]								                          [81-100]

  */
  public static INTERVAL_HEARTBIT_STAGE_2 = 30000;
  public static INTERVAL_HEARTBIT_STAGE_3 = 60000;
  public static INTERVAL_HEARTBIT_STAGE_4 = 120000;
  public static INTERVAL_HEARTBIT_STAGE_5 = 300000;

  /**Maximum number of (failed) attempts to contact the API server that the app considers still-manageable.
   * After this, the app will apply special procedures (FOR EXAMPLE, it may decree the reboot of the device).
   */
  public static INTERVAL_HEARTBIT_MAX_ATTEMPTS_LIMIT = 100;
  public static INTERVAL_HEARTBIT_STAGE_LAST =
    AppSettings.INTERVAL_HEARTBIT_STAGE_5;

  public static DEFAULT_INTERVAL_PRELOGIN_HEARTBIT = 5000;

  public static DEFAULT_LAN_TIMEOUT_MS = 4000;
  public static DEFAULT_WAN_TIMEOUT_MS = 10000;

  //#endregion

  //#region Reservation handling constant
  public static DEFAULT_RESERVATION_CYCLICAL_FETCHING_ELAPSE_MS = 600000; //10 minutes
  public static DEFAULT_RESERVATION_MINIMUM_CHECKIN_DATE = "1999-01-01";
  //#endregion

  public static DEFAULT_FORM_DEBOUNCE_TIME = 500;

  public static DATETIME_ISO_8601_FORMAT = "yyyy-MM-dd'T'HH:mmxxx";

  public static LANGUAGE_SYSTEM_AVAIABLE = ["it", "en", "fr", "es", "de"];
  public static DEFAULT_DEVICE_ADMIN_PASSWORD = "88888888";

  //#region ABB Millenium Mifare Data
  public static ABB_MILLENIUM_DEFAULT_SECTOR: number = 2;
  public static ABB_MILLENIUM_DEFAULT_BLOCK: number = 0;
  public static ABB_TACTEO_DEFAULT_UID_BLOCK: number = 0;
  public static ABB_TACTEO_DEFAULT_DATA_BLOCK: number = 1;
  public static ABB_TACTEO_DEFAULT_IV_EX_STRING: string =
    "00000000000000000000000000000000";
  public static ABB_MILLENIUM_DEFAULT_KEY_A: string = "FFFFFFFFFFFF";
  public static ABB_MILLENIUM_DEFAULT_KEY_B: string = "FFFFFFFFFFFF";
  //#endregion

  //#region Routing paths
  public static PATH_TO_SETTINGS = "/reserved-area/settings";

  //#endregion

  //#region Licence
  //Value used server-side to mean "no limit"
  public static LICENCE_UNLIMITED_VALUE: number = 2000000000;
  //#endregion

  //#region Remote Server API URL
  public static API_REMOTE_URL_LOG = "/b3/api/log";
  //#endregion

  //#region BIGStudio3 Api URL
  public static API_URL_ACCESS_HISTORY = "/api/history/access";
  public static API_URL_PRESENCE_HISTORY = "/api/history/presence";
  public static API_URL_AREA = "/api/area";
  public static API_URL_AREA_TREE = "/api/area/tree";
  public static API_URL_USER = "/api/user";
  public static API_URL_AUTH_USER = "/api/authentication";
  public static API_URL_SYSTEM = "/api/system";
  public static API_URL_SCHEDULE = "/api/schedule";
  public static API_URL_REPORT_HTML = "/api/reporthtml";
  public static API_URL_REPORT_HTML_EXPORT = "/api/reporthtml/export";
  public static API_URL_REPORT_HTML_IMPORT = "/api/reporthtml/import";
  public static API_URL_SCENARIO = "/api/scenario";
  public static API_URL_CALENDAR = "/api/calendar";
  public static API_URL_GATEWAY = "/api/gateway";
  public static API_URL_GATEWAY_SETTINGS = "/api/gateway/setting";
  public static API_URL_GATEWAY_KNX_IMPORT = "/api/gateway/knx/import";
  public static API_URL_GATEWAY_MQTT = "/api/gateway/mqtt";
  public static API_URL_NOTIFICATION = "/api/notification";
  public static API_URL_LOGIC = "/api/logic";
  public static API_URL_CUSTOMINTERFACE = "/api/custominterface";
  public static API_URL_DEVICE = "/api/device";
  public static API_URL_DEVICE_CONFIG = "/api/device/config";
  public static API_URL_DEVICE_UNLOCK = "/api/device/unlock";
  public static API_URL_KNOWN_DEVICE = "/api/device/known";
  public static API_URL_CUSTOMERS = "/api/customerstaff";
  public static API_URL_USER_INTEGRATION = "/api/user/integration";

  public static API_URL_ENVIRONMENT = "/api/environment";
  public static API_URL_PERMISSION = "/api/permission";
  public static API_URL_ENVIRONMENT_DEVICE = "/api/environment/device";
  public static API_URL_ENVIRONMENT_CONFIG = "/api/environment/config";
  public static API_URL_ENVIRONMENT_GRAPHIPAGE = "/api/environment/graphicpage";
  public static API_URL_COMMUNICATION = "/api/communication";
  public static API_URL_TIMESLOT = "/api/timeslot";
  public static API_URL_GROUP_TIMESLOT = "/api/timeslot/abb/mac/group";
  public static API_URL_CARD = "/api/card";
  public static API_URL_CHART = "/api/chart";
  public static API_URL_CARD_ENVIRONMENT = "/api/card/environments";
  public static API_URL_PLANTCODE = "/api/plantcode";
  public static API_URL_CHART_SERIE_CHANGE_GRANULARITY =
    "/api/chart/serie/changegranularity";
  public static API_URL_VERSION = "/api/system/version";
  public static API_URL_LICENCE = "/api/licence";
  public static API_URL_FILE_UPLOAD = "/api/file/upload";
  public static API_URL_QRCOODE = "/api/qrcode";
  public static API_URL_WEEKLYPLANNING = "/api/weeklyplanning";
  public static API_URL_EXPENSES_NOTE = "/api/expensenote";

  public static API_URL_WEEKLYPLANNINGACTION =
    "/api/weeklyplanning/weeklyplanningaction";
  public static API_URL_WEEKLYPLANNING_COPY = "/api/weeklyplanning/copy";
  public static API_URL_WEEKLYPLANNING_DUPLICATE =
    "/api/weeklyplanning/duplicate";
  public static API_URL_ADDRESS = "/api/address";
  public static API_URL_ADDRESS_TREE = "/api/address/tree";
  public static API_URL_ADDRESS_FUNCTION = "/api/addressfunction";
  public static API_URL_WEEKLYPLANNINGCALENDARS =
    "/api/weeklyplanning/weeklyplanningcalendar";

  public static API_URL_VIDEOCAMERA = "/api/videocamera";
  public static API_ACCOUNTING_ENTITY = "/api/accounting/entities";
  public static API_ACCOUNTING_ENTITY_GENERATE =
    "/api/accounting/notes/generate";
  public static API_ACCOUNTING_ENTITY_GENERATEFILE =
    "/api/accounting/notes/generatefile";
  public static API_ACCOUNTING_NOTES = "/api/accounting/notes";
  public static API_ACCOUNTING_NOTESSAVE = "/api/accounting/notes/save";
  public static API_URL_CONTROL_GROUP = "/api/controlgroup";
  public static API_URL_CONTROL = "/api/controlgroup/control";
  public static API_URL_TRANSLATION = "/api/translation";
  public static API_URL_ADDRESSES_FORWARD = "/api/addressesforward";
  public static API_URL_LOGIC_LOG = "/api/logic/log";
  public static API_URL_SYNCHRONIZATION = "/api/system/network/configuration";
  public static API_URL_DUPLICATE_CONTROL_GROUP = "/api/controlgroup/duplicate";
  public static API_URL_DUPLICATE_CONTROL =
    "/api/controlgroup/control/duplicate";
  public static API_URL_MEDIA = "/api/media";
  public static API_URL_VALIDATE_QUERY = "/api/genericquery/validatequery";
  public static API_URL_RESERVATION = "/api/reservation";
  public static API_URL_CARD_PROGRAMMER = "/api/cardprogrammer";
  public static API_URL_SMART_COMPONENT = "/api/smartcomponent";
  public static API_URL_RTUEVO_COUNTER = "/rtuevo/counter";
  public static API_URL_BILL = "/api/bill";
  public static API_URL_RESIDENT = "/api/resident";
  //#endregion

  public static API_URL_ANACI_USER = "/user";
  public static API_URL_ANACI_BUILDING = "/building";
  public static API_URL_ANACI_INVITATION = "/invitation";
  public static API_URL_ANACI_AUTH = "/auth";
  public static API_URL_QUOTE = "/quote";
  public static API_URL_DOCUMENT_SECURITY = "/document-security";
  public static API_URL_VOTING = "/voting";
  public static API_URL_QUOTES = "/quotes";
  public static API_URL_AWS_BILL = "/bill";
  public static API_URL_CONSUMPTION = "/api/consumption";

  //#endregion

  //#region  direct-access/plant-synchronisation URL
  public static URL_SYNCH_ACCESS_ARGO_MINIMUM_API_VERSION_MAJOR = "3";
  public static URL_SYNCH_ACCESS_ARGO_MINIMUM_API_VERSION_MINOR = "800";
  public static URL_SYNCH_ACCESS_ARGO_MINIMUM_API_VERSION_BUILD = "301";

  //#endregion

  public static ARGO_CLOUD_DEFAULT_PORT = "443";
  public static ARGO_CLOUD_GENERAL_ENDPOINT_SUBSTRING = ".bigstudio.cloud";
  public static ARGO_CLOUD_API_ENDPOINT_SUBSTRING = "api.bigstudio.cloud";
  public static URL_SYNCH_ONLY_PREFIX = "SYNCHONLY";
  public static URL_SYNCH_ACCESS_RECOGNITION_PATTERN = "/directUrl?auth=";
  public static URL_SYNCH_ACCESS_DEFAULT_LANGUAGE = "en";
  public static URL_SYNCH_ACCESS_DEFAULT_LISTVIEW = true;

  //#endregion

  //#region Storage Key
  public static KEY_TRANSLATION = "translations";
  public static KEY_SUPERVISIONS = "supervisions";
  public static KEY_SUPERVISION_COMPONENTS = "supervisionComponents";
  public static KEY_SCENARIOS = "scenarios";
  public static KEY_SCENARIOS_COMMANDS = "scenariosCommands";
  public static KEY_PLANTS = "plants";
  public static KEY_BUILDINGS = "buildings";
  public static KEY_SCHEDULES = "schedules";
  public static KEY_REPORTHTML = "reportHTML";
  public static KEY_ACCESS_HISTORY = "accessHistory";
  public static KEY_ACCOUNTING_ENTITIES = "accountingEntities";
  public static KEY_WEEKLYPLANNING = "weeklyplanning";
  public static KEY_ENVIRONMENT = "environments";
  public static KEY_ENVIRONMENT_ACCESS_USER_OPENABLE =
    "environmentsAccessUserOpenable";
  public static KEY_ENVIRONMENT_DEVICE = "environmentsDevices";
  public static KEY_ENVIRONMENT_ACCESS_CONTROL_MAINTANANCE =
    "environmentAccessControlMaintanance";
  public static KEY_USER = "user";
  public static KEY_SETTINGS = "serverSettings";
  public static KEY_REMEMBER = "remember";
  public static KEY_NOTIFICATION = "notifications";
  public static KEY_CALENDAR = "calendar";
  public static KEY_CURRENT_PLANT = "currentPlant";
  public static KEY_CURRENT_BUILDING = "currentBuilding";
  public static KEY_PLANT_CODES = "plantCodes";
  public static KEY_CLIENT_OPTIONS = "clientSettings";
  public static KEY_COSTUMERS_STAFF = "customerstaff";
  public static KEY_TIMESLOT = "timeSlots";
  public static KEY_GROUP_TIMESLOT = "groupTImeSlots";
  public static KEY_QRCODES = "qrCodes";
  public static KEY_CUSTOMINTERFACEAGGREGATEORDER_ =
    "customInterfaceAggregateOrder_";
  public static KEY_LOCAL_STORAGE_VERSION = "local_storage_version";
  public static KEY_WEEKLYPLANNINGACTION = "weeklyplanningaction";
  public static KEY_CONTROLGROUP = "controlgroup";
  public static KEY_ADDRESSESFORWARD = "addressesforward";
  public static KEY_GATEWAYS = "gateways";
  public static KEY_GATEWAYS_SETTINGS = "gatewayssettings";
  public static KEY_MY_ACCESSES_ORDER = "myAccessesOrder";

  public static KEY_ADDRESSTREE = "treeaddress";
  public static KEY_AREA = "areas";
  public static KEY_CHART = "chart";
  public static KEY_LOGICS_LOG = "logic_log";
  public static KEY_DEVICE_CARD_LIST = "deviceCardList";
  public static KEY_CARD_ENVIRONMENT = "cardEnvironments";
  public static KEY_RESERVATIONS = "reservations";
  public static KEY_HISTORY_TRANSIT = "historyTransit";
  public static KEY_CARD_PROGRAMMER = "cardProgrammer";

  public static KEY_SMART_COMPONENT = "smartComponents";
  public static KEY_BLACK_BOX = "blackBox";

  //public static KEY_CLIENT_OPTIONS_SUPERVISION_VIEW_MODE = "supervisionViewNormaleMode";
  //public static KEY_CLIENT_OPTIONS_DEFAULT_LANGUAGE = "defaultLanguage";
  //#endregion

  public static URI_PARENT_RESERVED_AREA: string = "/reserved-area";
  public static URI_HOME_RESERVED_AREA: string = "/reserved-area/intermediate";
  public static URI_ENTRY_APPLICATION: string = "/home";
  public static URI_PLANT_LIST_LOGIN: string = "/local/plant/login";
  public static URI_SINGLE_PLANT_LOGIN_GOBACK: string =
    "/local/plant/list?showBackButton=navigateBack";
  public static URI_PLANT_LIST_PAGE: string =
    "/local/plant/list?showBackButton=false";
  public static URI_SINGLE_PLANT_MANUAL: string = "/local/plant/manual/1";
  public static URI_SINGLE_SELECT_PLANT_MANUAL: string =
    "/local/plant/manual/-1";
  public static URI_SINGLE_SELECT_DIRECT_PLANT: string =
    "/local/plant/direct/sync";

  public static URI_DIGITAL_PLACE_HOME_RESERVED_AREA: string =
    "/reserved-area/building-list";

  public static NUMBER_ALLOW_UNAUTHORIZE_LOGIN_BEFORE_BLOCK = 5;
  public static QRCODE_NAME_RADIX = "QRCode_";

  public static SECOND_TO_EXECUTE_ACTION_TELEGRAM = "4";

  //#region Gateway GUID
  public static INSTANCE_GUID_OMNIA = "22222222-2222-2222-2222-222222222222";
  public static INSTANCE_GUID_VIRTUAL_VARIABLE =
    "11111111-1111-1111-1111-111111111111";
  public static INSTANCE_GUID_MASTER = "00000000-0000-0000-0000-000000000000";
  //#endregion

  //#region
  public static ADDRESS_INFO = "INFO";
  public static MIDDLE_CONNECTION_NAME = "Connection";
  public static LOWER_SUMMARY_NAME = "Summary";
  public static LOWER_TCP_NAME = "TCP";
  //#endregion

  //#region MQTT Keys

  //#endregion

  //#region KiokMode handling
  /**Number of taps needed in order to signal the intention to exit from "KioskMode" */
  public static KIOSKMODE_DISABLING_TAPS_NUMBER = 5;

  /**Interval (in milliseconds) during which the number of taps/clicks that are needed to signal the intention to exit from "KioskMode" MUST be
   * registered.
   */
  public static KIOSKMODE_DISABLING_RECEPTIVE_INTERVAL = 2000;
  //#endregion

  //Handle autoclose kiosk popup keypad exit
  public static KIOSK_POPUP_PASSWORD_AUTOCLOSE_TIMEOUT = 10;

  /**Handle how often the "text" property of graphical component is checked for eventual replacement of temporal value. THIS IS THE DEFAULT; GENERIC INTERVAL.
   *
   * Expressed in seconds.
   */
  public static TEMPORAL_KEYWORD_SYNC_DEFAULT_INTERVAL = 1;

  //#region Regex
  public static PATTERN_IP =
    "(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  public static PATTERN_PWD =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
  public static PATTERN_EMAIL =
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  public static PATTERN_JOLLY = /^BIG\$tudi0!\d{2,4}$/;

  public static PATTERN_CADRCODE_BLUMOTIX5 = "^[1-5]+$"; //Only numbers from 1 to 5
  public static PATTERN_LABEL_BUTTON_KEYWORD =
    /(#value|#formattedvalue|#timestamp|#name|#fullname|#address|#hileveldataformat|#techvalue|#measureunit|#roomnumber|#roomname|#virtualroomnumber|#virtualroomname|#decimaldigits)/g;

  public static PATTERN_ARGO_CLOUD_IP = new RegExp(`^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)*[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?${AppSettings.ARGO_CLOUD_GENERAL_ENDPOINT_SUBSTRING.replace(/\./g, "\\.")}$`, "i");
  //#endregion

  public static LAT_IT = "41.87194";
  public static LON_IT = "12.56738";

  public static PDF_GENERAL_CONDITION =
    "/assets/docs_dp/DigitalPlace_CondizioniGenerali_v_01_2023.pdf";
  public static PDF_PRIVACY_POLICY =
    "/assets/docs_dp/DigitalPlace_Informativa_PrivacyPolicy_v_1_2023.pdf";
  public static PDF_DPA = "/assets/docs_dp/DigitalPlace_DPA_v_01_2023.pdf";

  public static NEW_CONDO = "Nuovo condominio";

  public static IDKNOWDEVICE_UNKNOWN = 4;

  public static URL_ICONS_REPOSITORY = "https://d2lif27rkvg6ka.cloudfront.net/";

  //#region Host page ID for error content component
  public static ERROR_CONTENT_HOSTPAGE_ID_SUPERVISIONS = 1;
  public static ERROR_CONTENT_HOSTPAGE_ID_SUPERVISION_GRAPHIC = 2;
  public static ERROR_CONTENT_HOSTPAGE_ID_SUPERVISION_LIST = 3;
  public static ERROR_CONTENT_HOSTPAGE_ID_URL_ACCESS_CONFIGURATION = 4;
  //#endregion
  public static DEFAULT_API_PORT = "8020";
  public static DEFAULT_WS_PORT = "8022";

  public static BROWSER_SHOW_SAVE_FILE_PICKER = "showSaveFilePicker";
}
//
